webpackJsonp([7],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(281);


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = pageData;
	
	var _jsBase = __webpack_require__(86);
	
	var BASEKEY = 'x0DE7';
	function decodeFromBase64(base64Str_x0) {
	    if (typeof base64Str_x0 !== 'string') {
	        return base64Str_x0;
	    }
	    if (base64Str_x0.slice(0, BASEKEY.length) != BASEKEY) {
	        return base64Str_x0;
	    }
	    var base64Str = base64Str_x0.slice(BASEKEY.length, base64Str_x0.length);
	    try {
	        var str = decodeURIComponent(decodeURI(_jsBase.Base64.atob(base64Str)));
	        if (str && /^[ -\uD7FF\uE000-\uFFFF]*$/.test(str)) {
	            return str;
	        } else {
	            return base64Str;
	        }
	    } catch (e) {
	        // 解码失败，返回原始字符串
	        return base64Str;
	    }
	}
	
	function pageData(url) {
	    if (!url) return {
	        'page_type_detail': 'other',
	        'page_type': 'other'
	    };
	    function GetQueryString(name) {
	        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	        var r = decodeURIComponent(url.search).substr(1).match(reg);
	        if (r != null) return unescape(r[2]);return null;
	    }
	    function get_campaign_code(campaign_code) {
	        var arr = campaign_code && campaign_code.split(/intcmp=|kwrec=|prodlink=/) || [];
	        return arr.length > 1 ? arr[arr.length - 1] : null;
	    }
	    var pageTMP = {
	        "category": function category() {
	            var categoryId = url.pathname.split('/')[2];
	            var category = categoryId.split('-');
	            return {
	                'page_type_detail': 'category_list_' + category.length,
	                'page_type': 'List-page',
	                'categoryId': url.pathname.split('/')[2] || ""
	            };
	        },
	        "gift_set.html": function gift_setHtml() {
	            return {
	                'page_type_detail': 'gift_list',
	                'page_type': 'List-page'
	            };
	        },
	        "function": function _function() {
	            return {
	                'page_type_detail': 'function_list',
	                'page_type': 'List-page'
	            };
	        },
	        'exclusive_product.html': function exclusive_productHtml() {
	            return {
	                'page_type_detail': 'exclusive_list',
	                'page_type': 'List-page'
	            };
	        },
	        'search': function search() {
	            return {
	                'page_type_detail': 'search_list',
	                'page_type': 'List-page',
	                'key_words': decodeFromBase64(GetQueryString('k')),
	                'page_id': "WEB_1000311",
	                'action_id': "1000311_000"
	            };
	        },
	        'hot': function hot() {
	            return {
	                'page_type_detail': 'search_hot_list',
	                'page_type': 'List-page',
	                'key_words': decodeFromBase64(GetQueryString('k'))
	            };
	        },
	        'brand': function brand() {
	            var brand_id = url.pathname.split('/')[2] && url.pathname.split('/')[2].split('-')[1] || null;
	            var story = url.pathname.split('/')[2] && url.pathname.split('/')[2].split('-')[2] || null;
	            if (story) {
	                return {
	                    'page_type_detail': 'brand_story',
	                    'page_type': 'Campaign-page',
	                    'brand_id': story,
	                    'page_id': "WEB_1000213",
	                    'action_id': "1000213_000"
	                };
	            }
	            if (brand_id) {
	                return {
	                    'page_type_detail': 'brand_list',
	                    'page_type': 'List-page',
	                    'brand_id': brand_id
	                };
	            }
	            return {
	                'page_type_detail': 'brand_navigation',
	                'page_type': 'Navigation-page',
	                'action_id': "1000212_000",
	                'page_id': "WEB_1000212"
	            };
	        },
	        'product': function product() {
	            return {
	                'page_type_detail': 'product_detail',
	                'page_type': 'Product-detail-page',
	                'OP_code': url.pathname.split('/')[2].split('.')[0] || "",
	                'page_id': "WEB_1000401",
	                'action_id': "1000401_000"
	            };
	        },
	        'resetPasswords': function resetPasswords() {
	            return {
	                'page_type_detail': 'myaccount_resetPasswords',
	                'page_type': 'Function-page'
	            };
	        },
	        'cart': function cart() {
	            return {
	                'page_type_detail': 'cart',
	                'page_type': 'Function-page',
	                'page_id': "WEB_1000411",
	                'action_id': "1000411_000"
	            };
	        },
	        'checkout': function checkout() {
	            return {
	                'page_type_detail': 'checkout_order',
	                'page_type': 'Function-page'
	            };
	        },
	        'payment': function payment() {
	            return {
	                'page_type_detail': 'checkout_payment',
	                'page_type': 'Function-page'
	            };
	        },
	        'order': function order() {
	            return {
	                'page_type_detail': 'order_detail',
	                'page_type': 'Function-page',
	                'orderID': url.pathname.replace(/\/order-|\.html/gi, '') || ""
	            };
	        },
	        'myAccount': function myAccount() {
	            var pagename = url.pathname.split('/')[2] || null;
	            var data = {
	                'myCoupon': {
	                    'page_type_detail': 'myAccount_coupon',
	                    'page_type': 'Function-page',
	                    'action_id': "1000611_000",
	                    'page_id': "WEB_1000611"
	                },
	                'address': {
	                    'page_type_detail': 'address',
	                    'page_type': 'Function-page'
	                },
	                'management': {
	                    'page_type_detail': 'myAccount-management',
	                    'page_type': 'Function-page'
	                },
	                'integralFlow': {
	                    'page_type_detail': 'myAccount-integralFlow',
	                    'page_type': 'Function-page',
	                    'page_id': "WEB_1000142",
	                    'action_id': "1000142_000"
	                },
	                'myMemberCard': {
	                    'page_type_detail': 'member_card',
	                    'page_type': 'Function-page',
	                    'page_id': "WEB_1000162",
	                    'action_id': "1000162_000"
	                },
	                'modifyPassword': {
	                    'page_type_detail': 'myAccount-modifyPassword',
	                    'page_type': 'Function-page'
	                },
	                'changeHistory': {
	                    'page_type_detail': 'myAccount-changeHistory',
	                    'page_type': 'Function-page',
	                    'page_id': "WEB_1000143",
	                    'action_id': "1000143_000"
	                },
	                'issueInvoice': {
	                    'page_type_detail': "myAccount-Invoice",
	                    'page_type': "Function-page",
	                    'action_id': "1000425_000",
	                    'page_id': "WEB_1000425"
	                },
	                'profile.html': {
	                    'page_type_detail': 'user-info',
	                    'page_type': 'Function-page',
	                    'action_id': "1000601_000",
	                    'page_id': "WEB_1000601"
	                }
	            };
	            if (data[pagename]) return data[pagename];
	            return {
	                'page_type_detail': 'my_account',
	                'page_type': 'Function-page',
	                'action_id': "1000101_000",
	                'page_id': "WEB_1000101"
	            };
	        },
	        'login': function login() {
	            return {
	                'page_type_detail': 'login_in',
	                'page_type': 'Function-page'
	            };
	        },
	        'forgottenPassword': function forgottenPassword() {
	            return {
	                'page_type_detail': 'forget_password',
	                'page_type': 'Function-page'
	            };
	        },
	        'register': function register() {
	            return {
	                'page_type_detail': 'register',
	                'page_type': 'Function-page'
	            };
	        },
	        'my-account': function myAccount() {
	            // 废弃
	            return {
	                'page_type_detail': 'user-info',
	                'page_type': 'Function-page'
	            };
	        },
	        'myMemberCard': function myMemberCard() {
	            return {
	                'page_type_detail': 'member_card',
	                'page_type': 'Function-page',
	                'page_id': "WEB_1000163",
	                'action_id': "1000163_000"
	            };
	        },
	        'restMyCard': function restMyCard() {
	            return {
	                'page_type_detail': 'change-card',
	                'page_type': 'Function-page'
	            };
	        },
	        'content': function content() {
	            var content = url.pathname.split('/')[2] || null;
	            if (content && content === 'helpinfo') {
	                return {
	                    'page_type_detail': 'help-center',
	                    'page_type': 'Function-page',
	                    'page_id': "WEB_1000061",
	                    'action_id': "1000061_000"
	                };
	            }
	            if (content && content === 'memberclub') {
	                return {
	                    'page_type_detail': 'memberclub',
	                    'page_type': 'Function-page',
	                    'page_id': "WEB_1000161",
	                    'action_id': "1000161_000"
	                };
	            }
	            if (content && content === 'card') {
	                return {
	                    'page_type_detail': 'content_card',
	                    'page_type': 'Function-page',
	                    'page_id': "WEB_1000164",
	                    'action_id': "1000164_000"
	                };
	            }
	            return {
	                'page_type_detail': 'content',
	                'page_type': 'Function-page'
	            };
	        },
	        'updatePassword': function updatePassword() {
	            return {
	                'page_type_detail': 'updatePassword',
	                'page_type': 'Function-page'
	            };
	        },
	        'memberLogin': function memberLogin() {
	            return {
	                'page_type_detail': 'memberLogin',
	                'page_type': 'Function-page'
	            };
	        },
	        'confirmProduct': function confirmProduct() {
	            return {
	                'page_type_detail': 'confirmProduct',
	                'page_type': 'Function-page'
	            };
	        },
	        'campaign': function campaign() {
	            var changehistory = url.pathname.split('/')[2] || null;
	            if (changehistory && changehistory === 'changehistory') {
	                return {
	                    'page_type_detail': 'point_redemption_record',
	                    'page_type': 'Campaign-page'
	                };
	            }
	            return {
	                'page_type_detail': 'campaign_page',
	                'page_type': 'Campaign-page',
	                'campaign_code': decodeURIComponent(get_campaign_code(url.href))
	            };
	        },
	        'myOrderList': function myOrderList() {
	            return {
	                'page_type_detail': 'my_order_list',
	                'page_type': 'Function-page'
	            };
	        },
	        'logisticsInfo': function logisticsInfo() {
	            return {
	                'page_type_detail': 'myaccount_logistics',
	                'page_type': 'Function-page'
	            };
	        },
	        'wxBindCard': function wxBindCard() {
	            return {
	                'page_type_detail': 'myaccount_wxBindCard',
	                'page_type': 'Function-page'
	            };
	        },
	        'wxChooseCard': function wxChooseCard() {
	            return {
	                'page_type_detail': 'myaccount_wxChooseCard',
	                'page_type': 'Function-page'
	            };
	        },
	        'orderPaymentSuccess': function orderPaymentSuccess() {
	            return {
	                'page_type_detail': 'order_paymentSuccess',
	                'page_type': 'Function-page'
	            };
	        },
	        'weeklyspecials': function weeklyspecials() {
	            return {
	                'page_type_detail': 'weeklyspecials',
	                'page_type': 'Campaign-page',
	                'campaign_code': decodeURIComponent(get_campaign_code(url.href))
	            };
	        },
	        'rank': function rank() {
	            return {
	                'page_type_detail': 'rank',
	                'page_type': 'Campaign-page'
	            };
	        },
	        'error': function error() {
	            return {
	                'page_type_detail': 'error',
	                'page_type': 'error'
	            };
	        },
	        'home': function home() {
	            return {
	                'page_type_detail': 'home',
	                'page_type': 'home'
	            };
	        }
	    };
	    var pathname = url.pathname === '/' ? 'home' : url.pathname.split('/')[1];
	    pathname = pathname.indexOf('order-') === 0 ? 'order' : pathname;
	    pathname = pathname === 'brands' ? 'brand' : pathname;
	    var obj = pathname && pageTMP[pathname] && pageTMP[pathname]() || {
	        'page_type_detail': 'other',
	        'page_type': 'other'
	    };
	    return obj;
	}

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _SensorPageMap = __webpack_require__(196);
	
	var _SensorPageMap2 = _interopRequireDefault(_SensorPageMap);
	
	var _jsBase = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(document).ready(function () {
	
	    function getEnv(title, value) {
	        switch (title) {
	            case 'node':
	                return JSON.parse(process.env.GlobalEnv)[value];
	            case 'browser':
	                return window.__INITIAL_ENV__[value];
	            default:
	                break;
	        }
	    }
	
	    function getScript() {
	        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };
	
	        if (!url) return false;
	        var script = document.createElement("script");
	        script.async = options.async;
	        script.src = url;
	        var container = document.getElementsByTagName("script")[0];
	        container.parentNode.insertBefore(script, container);
	    }
	
	    var staticUrl = getEnv(process.title, "static");
	
	    // sensor suid
	    if (typeof window.GetSingleCookie === 'function') {
	        if (!window.GetSingleCookie(document.cookie, 'sepcuid') || !window.GetSingleCookie(document.cookie, 'sepcuid').match(/^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/)) {
	            $.post('/api/SOA/authentication/sepcuid');
	        }
	    }
	
	    // sensor setup
	    function sensor_setup(staticUrl) {
	
	        var env = null,
	            stat = null,
	            config = {};
	
	        if (staticUrl.restfulEnv) env = staticUrl.restfulEnv;
	        if (staticUrl.static) stat = staticUrl.static;
	
	        if (env && stat) {
	            config = setup_configuration(env, stat);
	        }
	
	        if (env === "stage" || env === "production") {
	
	            var para = config;
	            var p = para.sdk_url,
	                n = para.name,
	                w = window,
	                d = document,
	                s = 'script',
	                x = null,
	                y = null;
	            w['sensorsDataAnalytic201505'] = n;
	            w[n] = w[n] || function (a) {
	                return function () {
	                    (w[n]._q = w[n]._q || []).push([a, arguments]);
	                };
	            };
	            var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	            for (var i = 0; i < ifs.length; i++) {
	                w[n][ifs[i]] = w[n].call(null, ifs[i]);
	            }
	
	            if (!w[n]._t) {
	                x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	                x.async = 1;
	                x.src = p;
	                y.parentNode.insertBefore(x, y);
	
	                w[n].para = para;
	            }
	            // console.log('base63',Base64)
	            var pageData = _jsBase.Base64.decode(window.NewpageType);
	            var obj = Object.assign({}, JSON.parse(pageData));
	            w.timeString = w.timeString || String(new Date().valueOf()) + String(Math.floor(Math.random() * 1000));
	            obj.timeString = w.timeString;
	            obj.sensorTime = new Date().valueOf();
	            w[n].registerPage({
	                "current_url": w.location.href,
	                "platform_type": 'web',
	                "system_type": w.navigator.userAgent.indexOf("Windows") > 0 ? 'windows' : 'mac',
	                "environment_type": env,
	                "referrer": typeof document !== 'undefined' && typeof document.referrer === 'string' ? document.referrer : ''
	
	            });
	            w[n].quick('autoTrack', obj);
	
	            // }
	        }
	    }
	
	    sensor_setup(window.__INITIAL_ENV__);
	
	    // sensor configuration
	
	    // 1.4.1 普通参数
	    // 普通参数对代码埋点和可视化埋点都有效，下面是必填参数：
	
	    // sdk_url: sensorsdata.min.js 文件的地址，请从 GitHub 获取并且放在你们自己网站目录下。
	    // name: SDK 使用的一个默认的全局变量，如定义成 sa 的话，后面接可以使用 sa.track() 用来跟踪信息。为了防止变量名重复，你可以修改成其他名称比如 sensorsdata 等 。
	    // server_url: 数据接收地址。
	    // heatmap_url: （1.9以上版本新加） heatmap.min.js 文件的地址，在热力分析渲染页面时会用到，采集数据时候不会加载。
	    // 如果有需要，也可以修改可选参数：
	
	    // cross_subdomain: 设置成 true 后，表示在根域下设置 cookie 。也就是如果你有 zhidao.baidu.com 和 tieba.baidu.com 两个域，且有一个用户在同一个浏览器都登录过这两个域的话，我们会认为这个用户是一个用户。如果设置成 false 的话，会认为是两个用户。默认 true。
	    // show_log: 设置 true 后会在网页控制台打 logger，会显示发送的数据,设置 false 表示不显示。默认 true。
	    // use_client_time: 因为客户端系统时间的不准确，会导致发生这个事件的时间有误，所以这里默认为 false ，表示不使用客户端时间，使用服务端时间，如果设置为 true 表示使用客户端系统时间。如果你在属性中加入 {$time: new Date()} ，注意这里必须是 Date 类型，那么这条数据就会使用你在属性中传入的这个时间。
	    // source_channel: 默认取来源是根据 utm_source 等 ga 标准来的。如果你用的是百度统计的 hmsr 等参数。可以在这里面加入，参数必须是数组，比如 ['hmsr']。
	    // source_type: 自定义搜索引擎流量，社交流量，搜索关键词。具体用法参考 7.10 。
	    // is_single_page: 设置成 true 后， 表示在单页面开发的网站中，我们会对 hashchange 和 popstate 事件进行监听，当这两个事件任何一个发生时，也会发送 $pageview 事件。默认 false。详情参考 7.9 节。
	    // is_track_device_id:设置成 true 后， 表示事件属性里面添加一个设备 id 的属性，存贮在 cookie 里面并发送。默认 false，记录但不发送。
	    // send_type: 默认值 'image' 表示使用图片 get 请求方式发数据，( 神策系统 1.10 版本以后 ) 可选使用 'ajax' 和 'beacon' 方式发送数据，这两种默认都是 post 方式， beacon 方式兼容性较差，请参考 3.3.2 目录 。
	
	    function setup_configuration(env, stat) {
	        switch (env) {
	            case "stage":
	                return {
	                    sdk_url: stat + '/soa/public/js/sensor/1.15.11/sensorsdata.min.js',
	                    name: 'sa',
	                    server_url: 'https://sensorapi.sephora.cn/sa/?project=test',
	                    use_app_track: true,
	                    // web_url: 'https://sensorapi.sephora.cn/config?project=test',
	                    heatmap_url: stat + '/soa/public/js/sensor/1.15.11/heatmap.min.js',
	                    heatmap: {
	                        clickmap: 'default',
	                        scroll_notice_map: 'default',
	                        loadTimeout: 3000,
	                        collect_input: function collect_input() {
	                            return true;
	                        },
	                        element_selector: 'not_use_id',
	                        renderRefreshTime: 1000,
	                        scroll_delay_time: 4000
	                    }
	                };
	            case "production":
	                return {
	                    sdk_url: stat + '/soa/public/js/sensor/1.15.11/sensorsdata.min.js',
	                    name: 'sa',
	                    server_url: 'https://sensorapi.sephora.cn/sa/?project=default',
	                    show_log: false,
	                    use_app_track: true,
	                    // web_url: 'https://sensorapi.sephora.cn/config?project=default',
	                    heatmap_url: stat + '/soa/public/js/sensor/1.15.11/heatmap.min.js',
	                    heatmap: {
	                        clickmap: 'default',
	                        scroll_notice_map: 'default',
	                        loadTimeout: 3000,
	                        collect_input: function collect_input() {
	                            return true;
	                        },
	                        element_selector: 'not_use_id',
	                        renderRefreshTime: 1000,
	                        scroll_delay_time: 4000
	                    }
	                };
	            default:
	                return {};
	        }
	    }
	
	    // tealeaf
	    //getScript(staticUrl + "/soa/pc/js/tealeaf/v3/tealeaf.pc.js");
	    // deepLink => Component
	    // 360
	    // getScript("//s.union.360.cn/75002.js");
	    // baidu 
	    getScript("//hm.baidu.com/hm.js?26a309555c3997e904c1aac405e80335");
	    // qihoo
	    getScript("//t.agrantsem.com/tg.js?ang_tj=true&c=AG_075602_MDYR&t=1");
	
	    var _GoogleAnalyze = document.createElement("noscript");
	    _GoogleAnalyze.innerHTML = '<iframe src="//www.googletagmanager.com/ns.html?id=GTM-N57TLT" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
	    document.body.insertBefore(_GoogleAnalyze, document.body.firstElementChild);
	
	    // PZoom
	    // var _fxcmd = _fxcmd || [];
	    // _fxcmd.sid = '08988dd29da2ffe40d039ed7ec73f8c2';
	    // _fxcmd.trackAll = false;
	    // getScript("//static.w3t.cn/fx/1/1/fx.js");
	
	    // Media_V
	    /*var _mvq = window._mvq || [];
	    window._mvq = _mvq;
	    _mvq.push(['$setAccount', 'm-461-0']);
	    _mvq.push(['$logConversion']);
	    getScript('https:' == document.location.protocol ? 'https://cdn.dsp.com/static/js/loader.js' : 'http://cdn.dsp.com/static/js/loader.js');*/
	
	    // YOOULAN_START
	    /*var YLTrackerz = window.YLTrackerz = [];
	    YLTrackerz = { mid: 9, ers: [{ 'type': 'pageview' }], track: function(er) { this.ers.push(er); } };
	    getScript('https:' == document.location.protocol ? 'https://sstatic.bla01.com/s.js' : 'http://static.bla01.com/s.js')*/
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ })

});


// WEBPACK FOOTER //
// soa/bundle/track_4c18b9cd390ebf4103fc.js